export const CANDIDATES_LIST_PAGE = "/candidates";
